import { render, staticRenderFns } from "./RacerProfile.vue?vue&type=template&id=8bbcb6a4&scoped=true"
import script from "./RacerProfile.vue?vue&type=script&lang=js"
export * from "./RacerProfile.vue?vue&type=script&lang=js"
import style0 from "./RacerProfile.vue?vue&type=style&index=0&id=8bbcb6a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bbcb6a4",
  null
  
)

export default component.exports